import React from "react";
import { BrowserRouter } from "react-router-dom";
import routes from "./bundles/common/routes/common";
import { MenuContainer } from "./bundles/common/components/Menu";
import Footer from "./bundles/common/components/Footer/Footer";

const App = () => {
  // Sticky-footer 레이아웃 — 페이지 내용이 짧아도 푸터가 항상 화면 하단에 붙음.
  // flex column + minHeight:100vh, 본문 wrapper 에 flex:1. Menu 는 fixed=top 이라
  // flex item 으로 0 높이 — 본문 padding-top 은 각 페이지가 자체 관리.
  return (
    <BrowserRouter>
      <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        <MenuContainer />
        <div style={{ flex: 1 }}>{routes}</div>
        <Footer />
      </div>
    </BrowserRouter>
  );
};

export default App;
